import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ISettingsMailSmtp } from '@models';
import { Mapper } from '@services/generics/data.mapper';
import { MapperService } from '@services/mapper.service';

@Injectable()
export class MailService extends Mapper<ISettingsMailSmtp> {
    constructor(private _http: HttpClient) {
        super();
        this.mapper = MapperService.smtpParametersMap;
     }

    public send(sendTo: string, smtpSettings: ISettingsMailSmtp) {
        const smtpTestParameters = {
            sendTo: sendTo,
            smtpSettingModel: this._toPoco(smtpSettings),
        };

        return this._http.post('odata/Settings/UiPath.Server.Configuration.OData.VerifySmtpSetting',
            JSON.stringify(smtpTestParameters));
    }
}
